import {ReactNode, useState} from 'react';
import {view} from '@sail/ui';
import {TopBar} from '../TopBar';
import {Title} from './Title';
import {Description} from './Description';
import {UserInfo} from './UserInfo';
import {Codes} from './Codes';

type DetailsProps = {
  userName: string;
  userPhoneNumber: string;
  userCode: string;
  agentCode: string;
  error?: ReactNode;
  loading?: boolean;
};

type Props = DetailsProps & {
  isCalling: boolean;
  isCancelLoading: boolean;
  onCancel: () => void;
};

const Details = ({
  userName,
  userPhoneNumber,
  userCode,
  agentCode,
  error,
  loading,
}: DetailsProps) => (
  <>
    <Description />
    <UserInfo userName={userName} userPhoneNumber={userPhoneNumber} />
    <Codes
      userCode={userCode}
      agentCode={agentCode}
      error={error}
      loading={loading}
    />
  </>
);

export const RequestACallTopBar = ({
  userName,
  userPhoneNumber,
  userCode,
  agentCode,
  error,
  loading,
  isCalling,
  isCancelLoading,
  onCancel,
}: Props) => {
  const [showDetails, setShowDetails] = useState<boolean>(true);

  return (
    <TopBar data-testId="widget-request-a-call">
      <view.div css={{stack: 'y'}}>
        <Title
          showDetails={showDetails}
          isCalling={isCalling}
          isCancelLoading={isCancelLoading}
          onToggle={() => setShowDetails(!showDetails)}
          onCancel={onCancel}
        />
        {showDetails ? (
          <Details
            userName={userName}
            userPhoneNumber={userPhoneNumber}
            userCode={userCode}
            agentCode={agentCode}
            error={error}
            loading={loading}
          />
        ) : null}
      </view.div>
    </TopBar>
  );
};
